






import Vue from 'vue'
import Component from 'vue-class-component'
import { Inject, Prop } from 'vue-property-decorator'
import { loggerFor } from '@/shared/utils/logger'
import { Hooks } from '@/shared/interfaces/hooks'
import { Control, FormGroup } from '@tf/forms'
import { Step } from '@/shared/tf/stepper/step'
import TfStepper from '@/shared/tf/stepper/tf-stepper.vue'

@Component
export default class TfStep extends Vue implements Hooks, Step {
  @Inject()
  public readonly form?: FormGroup<any>

  @Inject()
  public readonly stepper!: TfStepper

  @Prop({
    type: String,
  })
  public readonly control?: string

  @Prop({
    type: String,
  })
  public readonly id?: string

  @Prop({
    required: false,
    type: String,
  })
  public readonly title?: string

  public active: boolean = false

  private logger = loggerFor(`Step ${this.control}`)

  get formControl(): Control<any> | undefined {
    let formControl: Control<any> | undefined

    if (this.control != null) {
      if (this.form === undefined) {
        this.logger.warn('A control name has been passed but there is no form available')
      } else {
        formControl = this.form.get(this.control)
      }
    }

    return formControl
  }

  get invalid(): boolean {
    return this.formControl?.invalid ?? false
  }

  public provide() {
    this.logger.debug('Providing', this.formControl)

    return {
      form: this.formControl,
    }
  }

  public toggleActive(active?: boolean): void {
    if (active === undefined) {
      this.active = !this.active
    } else {
      this.active = active
    }
  }
}
